<!--
 * @Author: zhouwei
 * @Date: 2020-04-10 11:03:52
 * @LastEditors: xiaokun
 * @LastEditTime: 2020-04-15 17:39:28
 * @Description: 学习任务
 -->
<template>
  <div class="list">
    <!-- 头部搜索栏 -->
    <list-biz
      :config="config"
      :data="listData"
      :total="total"
      :page="page"
      @on-current-change="handleOnCurrentChange"
      @on-publish-click="handleOnUpdateClick"
      @on-status-click="handleOnUpdateClick"
    >
      <ds-search
        slot="search"
        :form-schema="formSchema"
        @on-search-click="handleOnSearchClick"
        @on-reset-click="handleOnResetClick"
      >
        <mk-button
          slot="toolbar"
          type="primary"
          icon="el-icon-plus"
          @click="handleOnOpenClick"
        >
          新建学习任务
        </mk-button>
      </ds-search>
    </list-biz>

    <!-- 传递事件 -->
    <handle-btn @update="update" />
  </div>
</template>
<script>
import statusComponent from './components/status'
import handleBtn from './components/handle'
import endTime from './components/end-time'
import approval from './components/approval'
export default {
  components: {
    handleBtn
  },
  data () {
    return {
      config: {
        mode: 'table',
        list: {
          type: 'table',
          columns: [
            {
              prop: 'name',
              label: '任务名称',
              // 自定义组件
              component: null,
              showOverflowTooltip: true,
              minWidth: '250'
            },
            {
              prop: 'courseCount',
              label: '课程数',
              // 自定义组件
              component: null,
              minWidth: '70'
            },
            {
              prop: 'examCount',
              label: '考试数',
              // 自定义组件
              component: null,
              minWidth: '70'
            },
            {
              prop: 'status',
              label: '状态',
              // 自定义组件
              component: statusComponent,
              minWidth: 120
            },
            {
              prop: 'endTime',
              label: '结束时间',
              // 自定义组件
              component: endTime,
              minWidth: '90'
            },
            {
              prop: 'employeeName',
              label: '创建人',
              // 自定义组件
              component: null,
              showOverflowTooltip: true,
              minWidth: '120'
            },
            {
              prop: 'createTime',
              label: '创建时间',
              // 自定义组件
              component: null,
              minWidth: '160'
            },
            {
              prop: 'finishedCount',
              label: '已完成人数',
              // 自定义组件
              component: null,
              minWidth: '100'
            },
            {
              prop: 'noneApproveCount',
              label: '未审批试卷',
              // 自定义组件
              component: approval,
              minWidth: '100'
            },
            {
              prop: 'handle',
              label: '操作',
              width: '160px',
              fixed: 'right',
              // 自定义组件
              component: handleBtn
            }
          ]
        }
      },
      listData: [],
      total: 0,
      page: 1,
      formSchema: {
        name: {
          type: 'string',
          value: '',
          defaultValue: '',
          label: '',
          width: '240',
          placeholder: '输入名称',
          ui: {
            widget: 'MkInput', // 组件名
            widgetConfig: {} // 组件配置
          }
        },
        status: {
          type: 'number',
          value: null,
          defaultValue: null,
          label: '',
          width: '240',
          placeholder: '状态',
          ui: {
            widget: 'DsSearchSelect', // 组件名
            // 组件配置
            widgetConfig: {
              // 初始化数据
              data: [{
                value: 1,
                label: '未发布'
              }, {
                value: 2,
                label: '已发布'
              }, {
                value: 3,
                label: '发布且停用'
              }]
            }
          }
        }
      }
    }
  },
  mounted () {
    this.missionListPost()
  },
  methods: {
    update () {
      this.page = 1
      this.missionListPost()
    },
    handleOnOpenClick () {
      this.$router.push({
        path: '/business-school/learning-task/task'
      })
    },
    // 搜索
    handleOnSearchClick (params) {
      this.page = 1
      this.missionListPost()
    },
    handleOnResetClick (params) {
      this.formSchema.name.value = ''
      this.formSchema.status.value = null
    },
    // 获取列表数据
    async missionListPost () {
      let metas = {
        page: this.page,
        pageSize: 10,
        name: this.formSchema.name.value,
        status: this.formSchema.status.value || 0
      }
      const { success, data } = await MBASVCAPIS.MissionApi.missionListPost(metas)
      if (success) {
        this.listData = data.data
        this.total = data.total
      }
    },
    handleOnCurrentChange (e) {
      this.page = e
      this.missionListPost()
    },
    handleOnUpdateClick () {
      this.missionListPost()
    }
  }
}
</script>
<style lang="scss" scoped>
.list {
  width: 100%;
  height: 100%;
  box-sizing: border-box;

  /deep/ .list-biz {
    width: calc(100% - 40px);
    height: calc(100% - 40px);
    margin: 0 auto;
    padding-top: 10px;
  }

  // /deep/ .el-form {
  //   .el-form-item:nth-last-child(1) {
  //     margin-right: 0 !important;
  //   }
  // }
}
</style>
